<template>
  <div class="potential-box" :class="{'pc-potentali-box' : isPc}">
    <template v-if="isPc">
      <div class="pc-candidate-list-area-one">
        <div class="pc-candidate-profile">
          <img class="profile-photo"
            :title="potentialData.name"
            :src="[potentialData.is_candidate ? $DjangoMediaUrl(potentialData.photo_url) : potentialData.photo_url ]"
            @click="toJobDetailPage(potentialData.apply_job_id[0])"
            @error="getDefaultProfilePhoto($event)"/>
        </div>
        <div class="pc-candidate-job-info">
            <div class="job-name" :title="potentialData.apply_job_name[0]">{{ potentialData.apply_job_name[0] }}</div>
            <div class="candidate-name" :title="potentialData.name">{{ potentialData.name }}</div>
            <div class="pc-candidate-date-reward">
              <span>{{ formatCreateTime }}</span>
              <div v-if="isAppliedList && isShowHasGotReword" class="potential-reward">
                <span class="reward-icon">
                  <i class="iconfont iconcash1"></i>
                </span>
                <span>¥{{ potentialData.has_got_reward[0]|formatBigNumber(1) }}</span>
                <span class="divider-line">/</span>
                <span class="reward-icon">
                  <i class="iconfont iconpoint"></i>
                </span>
                <span>{{ potentialData.has_got_reward[1]|formatBigNumber(1) }}</span>
              </div>
            </div>
        </div>
      </div>
      <div class="candidate-right-icon">
        <i class="el-icon-arrow-right"></i>
      </div>
      <DetailReferralChain
        class="pc-candidate-list-area-two"
        :isPc="isPc"
        :referralChainInfo="potentialData.referral_chain"
        :jobId="potentialData.apply_job_id[0]"
        :shortUniqueId="potentialData.short_unique_id[0]"
        :isAppliedList="isAppliedList"
        />
      <div class="applied-page">
        <div v-if="isAppliedList" class="apply-status">
          <span>{{ $t(`admin.application.candidate.STATUS_GROUP.${potentialData.group_status_name}`) }}</span>
        </div>
        <div v-show="isShowMaxReword" class="future-reward">
          <span>{{ $t('personal.referrals.leads.reward.potential') }}</span>
          <span class="reward-icon">
            <i class="iconfont iconcash1"></i>
          </span>
          <span>¥{{ potentialData.max_rewards[0]|formatBigNumber(1) }}</span>
          <span class="divider-line">/</span>
          <span class="reward-icon">
            <i class="iconfont iconpoint"></i>
          </span>
          <span>{{ potentialData.max_rewards[1]|formatBigNumber(1) }}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="potentialData.is_top" class="top-badge">
        <div class="badge">{{ $t('personal.referrals.leads.label.top') }}</div>
      </div>
      <div class="potential-area-one">
        <div class="area-left">
          <div class="profile-photo-box">
            <img
              class="profile-photo"
              :title="potentialData.name"
              :src="[potentialData.is_candidate ? $DjangoMediaUrl(potentialData.photo_url) : potentialData.photo_url]"
              @error="getDefaultProfilePhoto($event)"/>
          </div>
          <div class="applied-message">
            <span class="job-name" :title="potentialData.apply_job_name[0]">{{ potentialData.apply_job_name[0] }}</span>
            <span class="candidate-name">{{ potentialData.name }}</span>
            <div class="potential-reward-date" :class="{'applied-potential-reward-date':isAppliedList}">
              <span class="applied-time">{{ formatCreateTime }}</span>
              <div v-if="isAppliedList" class="apply-status" :style="{'--status-group-color': appliedButtonColorMap[potentialData.group_status_name]}">
                <div class="apply-status-icon"></div>
                <span>{{ $t(`admin.application.candidate.STATUS_GROUP.${potentialData.group_status_name}`) }}</span>
              </div>
            </div>
            <div class="rewards-area">
              <div v-show="isShowMaxReword">
                <span>{{ $t('personal.referrals.leads.reward.potential') }}</span>
                <span class="reward-icon">
                  <i class="iconfont iconcash1"></i>
                </span>
                <span class="rewards-count">¥{{ potentialData.max_rewards[0]|formatBigNumber(1) }}</span>
                <span>/</span>
                <span class="reward-icon">
                  <i class="iconfont iconpoint"></i>
                </span>
                <span class="rewards-count">{{ potentialData.max_rewards[1]|formatBigNumber(1) }}</span>
              </div>
              <div v-show="isAppliedList && isShowHasGotReword" class="ptentail-referral-reward">
                <span class="reward-icon">
                  <i class="iconfont iconcash1"></i>
                </span>
                <span class="rewards-count">¥{{ potentialData.has_got_reward[0]|formatBigNumber(1) }}</span>
                <span>/</span>
                <span class="reward-icon">
                  <i class="iconfont iconpoint"></i>
                </span>
                <span class="rewards-count">{{ potentialData.has_got_reward[1]|formatBigNumber(1) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="chainListContainer" class="potential-area-two">
        <div v-show="showSimpleReferralChain" class="simple-referral-chain" @click="onSimpleReferralChainClick">
          <SimpleReferralChain class="referral-chain-content" :referralChainInfo="potentialData.referral_chain"/>
        </div>
        <div v-if="companyId && isAppliedList && !wxUserHasBindRewards" class="get-rewards">
          <van-button class="get-rewards-btn" @click="handleGetQrCode">{{ $t('personal.referrals.rewards.label.getRewards') }}</van-button>
        </div>
        <div v-show="shareTip.show" ref="shareTipContainer" class="share-tip" :style="shareTip.style">
          <p>{{ shareTip.content }}</p>
          <div class="tip-arrow" :style="shareTip.arrowStyle"></div>
        </div>
        <van-collapse v-model="activeNames" @change="onCollapseChanged">
          <van-collapse-item title="" name="displayReferralChain">
            <DetailReferralChain
              :referralChainInfo="potentialData.referral_chain"
              :jobId="potentialData.apply_job_id[0]"
              :shortUniqueId="potentialData.short_unique_id[0]"
              :isAppliedList="isAppliedList"
              @showShareTip="handleShowShareTip"
              @closeShowTips="handleCloseShareTip"
              />
          </van-collapse-item>
        </van-collapse>
      </div>
      <WeChatBindQrCodeDialog
        :show.sync="showWeChatBindQrCodeDialog"
        :companyId="companyId"
      ></WeChatBindQrCodeDialog>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import SimpleReferralChain from './simpleReferralChain.vue'
import DetailReferralChain from './detailReferralChain.vue'
import WeChatBindQrCodeDialog from './wechatBindQrCodeDialog.vue'
import moment from 'moment'

export default {
  components: {
    SimpleReferralChain,
    DetailReferralChain,
    WeChatBindQrCodeDialog
  },
  props: {
    potentialData: {
      type: Object,
      require: true
    },
    isAppliedList: {
      type: Boolean,
      default: false
    },
    isPc: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeNames: [],
      shareTip: {
        content: '',
        show: false,
        style: {},
        arrowStyle: {}
      },
      appliedButtonColorMap: {
        APPLY: '#0096cc',
        SCREEN: '#ffa600',
        INTERVIEW: '#05b54b',
        OFFER: '#0035ff',
        HIRED: '#ff006a'
      },
      tipNumber: 0,
      showWeChatBindQrCodeDialog: false
    }
  },
  computed: {
    ...mapGetters('account', ['wxUserHasBindRewards']),
    showSimpleReferralChain () {
      return this.activeNames.length === 0
    },
    getArrowLocation () {
      return 49 + this.potentialData.self_index * 102 + 'px'
    },
    isShowMaxReword () {
      // array[0] is cash, [1] is point
      return (this.potentialData.max_rewards[0] + this.potentialData.max_rewards[1]) > 0
    },
    isShowHasGotReword () {
      // array[0] is cash, [1] is point
      return (this.potentialData.has_got_reward[0] + this.potentialData.has_got_reward[1]) > 0
    },
    companyId () {
      return this.$route.query.company_id
    },
    formatCreateTime () {
      return moment(this.potentialData.create_time).format('YYYY-MM-DD HH:mm')
    }
  },
  created () {

  },
  methods: {
    handleGetQrCode () {
      if (!this.companyId) {
        return
      }
      this.showWeChatBindQrCodeDialog = true
    },
    handleShowShareTip ({ content, clientRect }) {
      this.shareTip.show = true
      this.shareTip.content = content
      this.$nextTick(() => {
        const containerRect = this.$refs.chainListContainer.getBoundingClientRect()
        const tipRect = this.$refs.shareTipContainer.getBoundingClientRect()
        let offsetLeft = _.clamp(clientRect.left - containerRect.left, 0, containerRect.width - tipRect.width)
        const offsetBottom = containerRect.bottom - clientRect.top + 15
        let arrowLeft = clientRect.left - offsetLeft
        if (arrowLeft < 5) {
          offsetLeft -= (5 - arrowLeft)
          arrowLeft = 5
        }
        this.shareTip.style = {
          left: `${offsetLeft}px`,
          bottom: `${offsetBottom}px`
        }
        this.shareTip.arrowStyle = {
          left: `${arrowLeft}px`
        }
      })
    },
    handleCloseShareTip () {
      this.shareTip.show = false
    },
    onSimpleReferralChainClick () {
      if (!this.activeNames.includes('displayReferralChain')) {
        this.activeNames.push('displayReferralChain')
      }
    },
    onCollapseChanged () {
      if (this.activeNames.length < 1) {
        this.shareTip.show = false
      }
    },
    toJobDetailPage (jobId) {
      if (this.isPc) {
        window.location.href = this.$DjangoBaseUrl(`/job-detail-new/${jobId}/c/`)
      } else {
        this.$router.push(`/job-description/${this.potentialData.short_unique_id[0]}`)
      }
    },
    getDefaultProfilePhoto (e) {
      e.target.src = this.$DjangoStaticUrl('images_en/default.jpg')
    }
  }
}
</script>

<style lang="scss" scoped>
.potential-box {
  display: flex;
  position: relative;
  background: #FFFFFF;
  border-radius: 10px;
  border-bottom: 1px solid #e5e5e5;
  padding: 10px 0 10px 0;
  flex-direction: column;

  .top-badge {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    overflow: hidden;
    z-index: 1;
    position: absolute;
    top: 0;
    right: 0;

    .badge {
      width: 65px;
      height: 30px;
      line-height: 40px;
      text-align: center;
      background: #15aa66;
      color: #ffffff;
      transform: rotateZ(45deg) translate(2px, -8px);
    }
  }

  .pc-candidate-list-area-one {
    display: flex;
    width: 45%;

    > .pc-candidate-profile {
      > img {
        width: 64px;
        height: 64px;
        box-shadow: 2px 1px 4px 0px #a8b2b5;
      }
    }

    > .pc-candidate-job-info {
      margin-left: 17px;
      overflow: hidden;

      .candidate-name, .job-name {
        font-size: 16px;
        line-height: 1.25;
        font-weight: 400;
        overflow: hidden;
        color: #666666;
        word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .job-name {
        font-size: 20px;
        overflow: hidden;
        white-space: nowrap;
        color: #333333;
        text-overflow: ellipsis;
      }

      .pc-candidate-date-reward {
        display: flex;
        align-items: center;

        > span {
          font-size: 14px;
          line-height: 17px;
          color: #666666;
          margin-right: 15px;
        }

        .future-reward {
          span {
            color: #888888;
            font-size: 12px;
            line-height: 14px;
          }
        }
      }
    }
  }

  .candidate-right-icon {
    display: flex;
    margin: 0 10px;
    align-items: center;

    .el-icon-arrow-right {
      font-size: 23px;
      opacity: 0.5;
    }
  }

  .pc-candidate-list-area-two {
    flex: 1
  }

  .applied-page {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 17px;

    span {
      color: #888888;
      font-size: 12px;
      line-height: 14px;
    }

    .apply-status {
      border-radius: 14px;
      display: flex;
      min-width: 64px;
      margin-right: 10px;
      align-items: center;
      border: 1px solid #666666;
      justify-content: center;
      padding: 2px 5px;
    }

    .divider-line{
      margin: 0 2px 0 2px;
    }

    .future-reward {
      display: flex;
      align-items: center;
    }
  }

  .potential-reward {
    display: flex;
    align-items: center;

    > span {
      color: var(--custom-color);
      font-size: 15px;
      line-height: 16px;

      > i {
        font-size: 17px;
      }
    }

    .divider-line {
      margin-left: 4px;
      margin-right: 2px;
    }
  }

  .reward-icon {
    padding: 0;
    line-height: 15px;

    > i {
      font-size: 15px;
    }
  }

  .rewards-count {
    margin-right: 5px;
  }

  .potential-area-one {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 20px 0 10px;
    padding: 10px 0px 15px 0px;
    border-bottom: 1px solid #bfbfbf;

    .area-left {
      display: flex;
      align-items: flex-start;
      width: 100%;
    }

    .area-right {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-end;
      width: 25%;
      height: 70px;
    }

    .applied-message {
      display: flex;
      flex-direction: column;
      margin: 0 0 0 10px;
      width: 80%;

      > span {
        color: #666666;
      }

      .job-message {
        display: flex;
      }

      .job-name {
        font-size: 18px;
        line-height: 1.25;
        color: #333333;
        text-overflow:ellipsis;
        overflow:hidden;
        white-space: nowrap;
      }

      .potential-reward-date {
        display: flex;
        margin-top: 2px;
        justify-content: space-between;
        align-items: flex-end;

        > span {
          font-size: 14px;
          color: #666666;
          word-break: keep-all;
        }

        .ptentail-referral-reward {
          padding: 0;
        }
      }

      .applied-potential-reward-date {
        justify-content: flex-start;
      }

      .rewards-area {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 6px;

        span {
          font-size: 12px;
          line-height: 12px;
          color: #888888;
          word-break: keep-all;
        }

        > div {
          display: flex;
          align-items: center;
        }

        .ptentail-referral-reward {
          padding: 0;

          ::v-deep span {
            color: var(--custom-color);
          }
        }
      }
    }

    .profile-photo-box {
      width: 20%;
      position: relative;

      .profile-photo{
        width: 60px;
        height: 60px;
        box-shadow: 0px 9px 11px -3px rgba(99, 114, 117, 0.7);
      }
    }

    .apply-status {
      border-radius: 14px;
      border: 1px solid #666666;
      margin-left: 10px;
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;

      > span {
        font-size: 11px;
        font-weight: 400;
        margin: 0 10px 0 0;
        color: #666666;
      }

      .apply-status-icon {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        margin: 0;
        margin-right: 6px;
        margin-left: 6px;
        background-color: var(--status-group-color, #0096cc);
      }
    }

    .ptentail-referral-reward {
      z-index: 1;
      display: flex;
      align-items: center;

      > span {
        color: var(--custom-color);
        padding: 0;
        font-size: 12px;
      }
    }

  }

  .potential-area-two {
    position: relative;

    .simple-referral-chain {
      position: absolute;
      z-index: 1;
      width: 35%;
      margin-top: 8px;
      margin-left: 12px;
    }

    .get-rewards {
      position: absolute;
      z-index: 1;
      margin-top: 8px;
      margin-left: 12px;
      right: 46px;
      .get-rewards-btn {
        height: 28px;
        padding: 0 28px;
        border-radius: 999px;
        border-color: var(--custom-color);
        color: #fff;
        background-color: var(--custom-color);
      }
    }

    .share-tip {
      max-width: 85%;
      padding: 5px;
      border-radius: 5px;
      background: #000000;
      color: #FFFFFF;
      font-size: 14px;
      position: absolute;
      z-index: 1;

      p {
        margin: 0;
        padding: 0;
      }

      .tip-arrow {
        width: 0;
        height: 0;
        margin-left: -5px;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid #000000;
        position: absolute;
        bottom: -5px;
        z-index: 10;
      }
    }

    ::v-deep {
      .van-cell--clickable {
        background: #fff;
        padding-bottom: 0;
      }

      .van-collapse-item__wrapper {
        border-radius: 10px;
      }

      .van-collapse-item__content {
        padding-top: 0;
        padding-bottom: 8px
      }

      .van-collapse-item__title--expanded::after {
        border: 0;
      }

      .van-hairline--top-bottom::after {
        border: 0;
      }
    }
  }
}
.pc-potentali-box {
  border-radius: 0;
  margin: 30px 20px 0 20px;
  flex-direction: row;
}

.pontential-item:last-child .pc-potentali-box {
  border-bottom: none;
}
</style>
